import Navbar from "./components/NavBar/navbar";
import Intro from "./components/Intro/intro";
import Skills from "./components/Skills/skills";
import Education from "./components/Education/education";
import Projects from "./components/Projects/project";
import Certificate from "./components/Certificates/certificates";
import Activity from "./components/Activities/activity";
import Language from "./components/Language/language";
import Contact from "./components/Contact/contact";
import Win from "./components/Competitions/comp"; 
import Experience from "./components/Experience/exp";
function App() {
  return (
    <div className="App">
      <Navbar />
      <Intro />
      <Education />
      <Experience/>
      <Skills />
      <Projects />
      <Certificate />
      <Activity />
      <Win />           
      <Language />
      <Contact />
    </div>
  );
}

export default App;
